import { addDays, differenceInMilliseconds } from 'date-fns';

// Returns the remaining time as structured parts so the caller can render it
// through an i18n message (the "{days}d {hours}h:{minutes}min" template lives in
// the message catalogues, per locale). Clamps to zero once the window has
// closed rather than emitting negative units.
const getTimeRemaining = ({ endDate, daysExtended = 0 }) => {
  const now = new Date();
  let end = new Date(endDate);

  if (daysExtended > 0) {
    end = addDays(end, daysExtended);
  }

  const ms = Math.max(differenceInMilliseconds(end, now), 0);

  return {
    days: Math.floor(ms / (1000 * 60 * 60 * 24)),
    hours: Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60))
  };
};

export default getTimeRemaining;
